<template>
  <div class="fluid att-card">
    <div class="card-body py-0 px-0 fluid">
      <!-- Layer name and close button -->
      <b-row class="att-header px-4 w-100" no-gutters align-v="center">
        <b-col class="capitalize att-title">
          {{ attributesName }}
        </b-col>
        <b-col cols="3" class="d-flex align-items-center justify-content-end">
          <button
            id="minOrMaxAttributeElement"
            type="button"
            class="header-icon-btn"
            :title="attributesMinimized ? 'Maximize Attributes' : 'Minimize Attributes'"
            @click="$emit(attributesMinimized ? 'maximizeAttributes' : 'minimizeAttributes')"
          >
            <fa :icon="['fas', attributesMinimized ? 'window-maximize' : 'window-minimize']" />
          </button>
        </b-col>
      </b-row>

      <!-- All attributes and their values -->
      <div v-show="!attributesMinimized" class="att-body">
        <b-row
          v-for="(resp, index) in attribResponse"
          :key="index"
          class="att-row w-100"
          no-gutters
          align-v="center"
        >
          <b-col class="att-text att-name" cols="6">{{ resp.name }}</b-col>
          <b-col
            :id="'editor' + index"
            cols="6"
            title="Copy Value"
            class="att-value"
            @click="copyText(resp.value)"
          >
            {{ resp.name == 'created_date' || resp.name == 'updated_date' ?  resp.value ? resp.value.replace('Z', '') : resp.value : resp.value }}
          </b-col>
        </b-row>
      </div>

      <!-- Pagination controls -->
      <b-row v-show="!attributesMinimized" class="att-footer w-100" no-gutters align-v="center">
        <b-col cols="6" class="d-flex flex-row align-items-center g-2">
          <button
            type="button"
            class="pager-btn"
            :disabled="feature_index < 1"
            @click="getNextFeature(-1)"
          >
            <fa :icon="['fas', 'chevron-left']" />
          </button>
          <span class="pager-count">{{ feature_index + 1 }} of {{ features.length }}</span>
          <button
            type="button"
            class="pager-btn"
            :disabled="feature_index + 1 >= features.length"
            @click="getNextFeature(1)"
          >
            <fa :icon="['fas', 'chevron-right']" />
          </button>
        </b-col>
        <b-col cols="6" class="d-flex justify-content-end align-items-center">
          <b-button class="close-btn px-4 py-2" @click="closeAttTable()">Close</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
/* ============ Card shell ============ */
.att-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(6, 60, 109, 0.18);
  background: #ffffff;
}

/* ============ Header ============ */
.att-header {
  background: linear-gradient(135deg, #0a4a85 0%, #063C6D 100%);
  color: #ffffff;
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.att-title {
  font-family: 'Inter Bold', sans-serif;
  font-size: 1.375rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}
.header-icon-btn:hover {
  background: rgba(255, 255, 255, 0.28);
  transform: translateY(-1px);
}

/* ============ Attribute rows ============ */
.att-body {
  max-height: 55vh;
  overflow-y: auto;
}
.att-row {
  padding: 0.5625rem 0;
  border-bottom: 1px solid #eef1f5;
  transition: background 0.12s ease;
}
.att-row:nth-child(even) {
  background-color: #f6f8fb;
}
.att-row:hover {
  background-color: #e8f0f9;
}
.att-text {
  font-family: 'Inter Regular', sans-serif;
  opacity: 1 !important;
  white-space: initial !important;
  word-wrap: break-word;
  text-overflow: ellipsis;
}
.att-name {
  padding-left: 1.5rem;
  color: #5a6b7b;
  font-size: 0.9rem;
  text-transform: capitalize;
}
.att-value {
  font-family: 'Inter Bold', sans-serif;
  padding-right: 1.5rem;
  color: #12324f;
  opacity: 1 !important;
  white-space: initial !important;
  word-wrap: break-word;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.12s ease;
}
.att-value:hover {
  color: #0a6bb5;
  text-decoration: underline;
}

/* ============ Footer / pagination ============ */
.att-footer {
  padding: 0.75rem 1.5rem;
  background: #f6f8fb;
  border-top: 1px solid #e5e9ef;
}
.pager-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  border: 1px solid #d4dbe4;
  border-radius: 50%;
  background: #ffffff;
  color: #063C6D;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.pager-btn:hover:not(:disabled) {
  background: #063C6D;
  border-color: #063C6D;
  color: #ffffff;
}
.pager-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.pager-count {
  margin: 0 0.625rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: #12324f;
  white-space: nowrap;
}
.close-btn {
  font-size: 0.8rem !important;
  background-color: #063c6d !important;
  border: none !important;
  border-radius: 20px !important;
  min-height: 2.375rem;
  min-width: 5.25rem;
  transition: background-color 0.15s ease, transform 0.15s ease;
}
.close-btn:hover {
  background-color: rgba(6, 60, 109, 0.85) !important;
  transform: translateY(-1px);
}

/* ============ Misc ============ */
.disabled-icon {
  pointer-events: none;
  opacity: 0.5;
}
.cursor-pointer {
  cursor: pointer;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'DT_Attributes',
  props: [
    'attributesName',
    'attributesMinimized',
    'attribResponse',
    'features',
    'feature_index'
  ],
  data() {
    return {
      disabledNext: false,
      disabledPrevious: false,
      index_item: null,
      names: null
    }
  },
  methods: {
    closeAttTable() {
      this.$emit('closeAttTable')
    },
    getNextFeature(modifier) {
      this.index_item = this.feature_index + modifier
      this.$emit('showNextAttribute', this.index_item)
    },
    copyText(attributeValue) {
      /* Writes value to user's clipboard and shows
      a toast that displays the copied data */
      if (String(attributeValue).includes('Z')) {
        // substring is contained in the string
        attributeValue=String(attributeValue).replace('Z','')
      }
     
      //Remove Z if exists from all the dates showing up in attribute panel.
      navigator.clipboard.writeText(attributeValue)
      this.$bvToast.toast(attributeValue, {
        autoHideDelay: 7000,
        title: 'Copied Value To Clipboard',
        toaster: 'b-toaster-top-right'
      })
    }
  }
}
</script>
